import "./LuggageSummaryAddButton.scss";
import { FormattedMessage } from "react-intl";
import { Button } from "app/components/ui/Button/Button";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { MoreIcon } from "app/icons/navigation";

const LuggageSummaryAddButton = ({ onLuggageClick = () => {} }) => {
	return (
		<>
			{": "}
			<Button
				variant="borderless"
				size="sm"
				startIcon={<MoreIcon width={12} height={12} />}
				onClick={onLuggageClick}
				className="luggage-summary-add-button"
				data-testid="luggage-summary-add"
			>
				<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold>
					<FormattedMessage id="quotation.luggage.bookable.label" />
				</Typography>
			</Button>
		</>
	);
};

LuggageSummaryAddButton.propTypes = {
	onLuggageClick: PropTypes.func,
};

export default LuggageSummaryAddButton;
